export function setMateTagTitle(title = {}) {
    return {
          type: "SET_MATE_TAG",
          metaTags: title
    }
  }